export default __webpack_public_path__ + "static/media/digitizeLine.c1c4099e.cur";